import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubAboutHeHeroContentSectionHeaderBigV1Cls: string;
			heHubAboutHeHeroContentSectionHeaderBigCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub About He Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeHeroContentSectionHeaderBigV1Cls || '', 'he_hub_about_he_hero', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeHeroContentSectionHeaderBigCls || '', 'he_hub_about_he_hero', { animCls: 'animate__fadeInDown50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;